import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../../../services/useAuth'

import Button from '../../../components/BaseUI/Button'
import Input from '../../../components/BaseUI/Input'
import Content from '../Content'

import { Toast, ToastContainer } from '../../../components/CustomUI/Toast'
import { useTitle } from '../../../hooks/useTitle'
import styles from './Login.module.scss'

import initialData from '../../../services/database/data'

export default function Login() {
  useTitle('Вход | CloverAI')

  const navigate = useNavigate()
  const { login } = useAuth()

  const [user, setUser] = useState({
    email: '',
    password: '',
  })
  const [toast, setToast] = useState()

  useEffect(() => {
    const worker = new Worker(
      new URL('../../../services/database/dbWorker.js', import.meta.url)
    )

    worker.postMessage(initialData)

    worker.onmessage = event => {
      if (event.data === 'Database initialized') {
        console.log('Initialization complete!')
      }
    }

    return () => {
      worker.terminate()
    }
  }, [])

  const sigin = () => {
    const url = localStorage.getItem('redirectTo')
    const parsedUrl = url ? JSON.parse(url) : null

    login(user.email, user.password).then(response => {
      if (response) {
        navigate(parsedUrl ? parsedUrl : '/', { replace: true })
        localStorage.removeItem('redirectTo')
      } else {
        setToast({
          id: 1,
          key: 1,
          title: 'Неверный email или пароль',
          appearance: 'danger',
        })
      }
    })
  }

  const removeToast = () => {
    setToast({})
  }

  return (
    <div className={styles['login-container']}>
      <Content title="Войдите в систему">
        <div className="mt-4">
          <Input
            type="email"
            label="Email"
            placeholder="Введите ваш email"
            className={styles['custom__input']}
            value={user.email}
            onChange={value => setUser({ ...user, email: value })}
          />

          <Input
            type="password"
            label="Пароль"
            placeholder="Введите пароль"
            className={styles['custom__input']}
            value={user.password}
            onChange={value => setUser({ ...user, password: value })}
          />
        </div>

        <div className={styles['forgot__password']}>
          <span onClick={() => navigate('/recover-password')}>
            Забыли пароль?
          </span>
        </div>

        <div className="mt-2">
          <Button
            title="Войти"
            appearance="primary"
            isBlock={true}
            onClick={() => sigin()}
          />
        </div>

        <div className={styles['register']}>
          <span>Нет аккаунта?</span>
          <span
            className={styles['create__account']}
            onClick={() => navigate('/register')}
          >
            Зарегистрироваться
          </span>
        </div>
      </Content>

      {toast?.id && (
        <ToastContainer onDismissed={removeToast}>
          <Toast {...toast} isExpanded />
        </ToastContainer>
      )}
    </div>
  )
}
